"use client";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { performanceMetrics as data } from "@/lib/data/status";

const accent = "var(--color-purple)";

const renderTable = (rows: { metric?: string; resource?: string; current: string; target?: string; status?: string; capacity?: string; utilization?: string; threshold?: string }[], type: "metric" | "throughput" | "resource") => (
  <Reveal>
    <h3 className="text-lg mt-10 mb-3">
      {type === "metric" ? "Core Performance Metrics" : type === "throughput" ? "Throughput Metrics" : "Resource Utilization"}
    </h3>
    <div className="glass rounded-2xl overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[rgb(var(--border)/0.18)] bg-[rgb(var(--border)/0.04)]">
              <th className="text-left px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Metric</th>
              <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Current</th>
              {type === "metric" ? (
                <>
                  <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Target</th>
                  <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Status</th>
                </>
              ) : type === "throughput" ? (
                <>
                  <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Capacity</th>
                  <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Utilization</th>
                </>
              ) : (
                <>
                  <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Threshold</th>
                  <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Status</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.metric ?? r.resource} className="border-b border-[rgb(var(--border)/0.08)]">
                <td className="px-4 py-3 align-top font-medium">{r.metric ?? r.resource}</td>
                <td className="px-4 py-3 align-top text-right font-mono text-xs" style={{ color: accent }}>{r.current}</td>
                {type === "metric" ? (
                  <>
                    <td className="px-4 py-3 align-top text-right hidden md:table-cell font-mono text-xs text-[rgb(var(--fg-muted))]">{r.target ?? ""}</td>
                    <td className="px-4 py-3 align-top text-right hidden md:table-cell"><span className="text-xs font-bold text-[var(--color-emerald)]">{r.status ?? ""}</span></td>
                  </>
                ) : type === "throughput" ? (
                  <>
                    <td className="px-4 py-3 align-top text-right hidden md:table-cell font-mono text-xs text-[rgb(var(--fg-muted))]">{r.capacity ?? ""}</td>
                    <td className="px-4 py-3 align-top text-right hidden md:table-cell font-mono text-xs">{r.utilization ?? ""}</td>
                  </>
                ) : (
                  <>
                    <td className="px-4 py-3 align-top text-right hidden md:table-cell font-mono text-xs text-[rgb(var(--fg-muted))]">{r.threshold ?? ""}</td>
                    <td className="px-4 py-3 align-top text-right hidden md:table-cell"><span className="text-xs font-bold text-[var(--color-emerald)]">{r.status ?? ""}</span></td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </Reveal>
);

export function PerformanceMetrics() {
  return (
    <Section id="performance-metrics" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-purple)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        {renderTable(data.core, "metric")}
        {renderTable(data.throughput, "throughput")}
        {renderTable(data.resources, "resource")}
        <Reveal delay={400}>
          <p className="mt-6 text-xs text-center text-[rgb(var(--fg-subtle))] font-mono">{data.refresh}</p>
        </Reveal>
      </Container>
    </Section>
  );
}
